<template>
  <div class="client-container">
    <div :style="{ overflow: 'hidden' }">
      <bread-crumb :style="{ float: 'left' }" />
      <table-search
        :style="{ float: 'right' }"
        @onSearch="onSearch"
        @editAndAdd="editAndAdd"
      />
    </div>
    <div class="global-table-container">
      <a-table
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="record => record.id"
        :pagination="{
          pageSize,
          total,
          current,
          showTotal: total => `共${total}条`
        }"
        @change="changePage"
      >
        <template
          slot="drugs_count"
          slot-scope="text, record"
        >
          <a @click="handleCompanyList(record)">{{ record.drugs_count }}</a>
        </template>
        <template
          slot="doctors_count"
          slot-scope="text, record"
        >
          <a @click="handleDoctorList(record)">{{ record.doctors_count }}</a>
        </template>
        <template
          slot="operation"
          slot-scope="text, record"
        >
          <a
            href="javascript:;"
            @click="() => handleScore(record)"
          >费用明细</a>
          <a-divider type="vertical" />
          <a
            href="javascript:;"
            @click="() => editAndAdd(record)"
          >编辑</a>
          <a-divider type="vertical" />
          <popconfirm-button
            :text="record.status === 1 ? '禁用' : '启用'"
            :alert-title="record.status === 1 ? '确定禁用？' : '确定启用？'"
            @onDelete="() => onConfirm(record)"
          />
          <a-divider type="vertical" />
          <a
            href="javascript:;"
            @click="bindArea(record)"
          >关联大区</a>
        </template>
      </a-table>
    </div>
    <add-edit-modal
      ref="formRef"
      :title="title"
      :visible="visible"
      :type-id="typeId"
      :btn-is-loading="btnIsLoading"
      @onCancel="onCancel"
      @handleSubmit="onSubmit"
    />
    <company-list
      :data="CompanyData"
      :visible="visibleCompany"
      @onCancel="onCancelCompany"
    />
    <doctor-list
      :data="doctorData"
      :visible="visibleDoctor"
      @onCancel="onCancelDoctor"
    />
  </div>
</template>
<script>
import { columns } from './data/index';
import TableSearch from './components/search';
import addEditModal from './modal/index';
import CompanyList from './modal/companyList.vue';
import DoctorList from './modal/doctorList.vue';
import areaPanel from './components/area';

var pageContext;
export default {
  components: { TableSearch, addEditModal, CompanyList, DoctorList },
  data() {
    return {
      columns,
      data: [],
      pageSize: 10,
      current: 1,
      total: 0,
      loading: false,
      btnIsLoading: false,
      title: '',
      visible: false,
      typeId: '',
      id: '',
      CompanyData: [],
      visibleCompany: false,
      doctorData: [],
      visibleDoctor: false,
    };
  },
  mounted() {
    pageContext = this;
    // 获取表格数据
    this.getTableData({
      page: this.current,
      pageSize: this.pageSize,
      keyword: this.keyword,
    });
  },
  methods: {
    // 获取表格数据
    async getTableData(params) {
      this.loading = true;
      let result = await this.$http.post('/promoter/adminGetList', params);
      console.log('TCL: getTableData -> result', result);
      if (result.data.status === 1) {
        this.loading = false;
        this.total = result.data.data.count;
        let data = result.data.data.data_list;
        let temp = [];
        data.forEach((item) => {
          let obj = {
            id: item.id,
            status: item.user_status,
            user_nickname: item.user_nickname,
            user_realname: item.user_realname,
            mobile: item.mobile,
            score: item.score,
            drugs_count: item.drugs_count,
            doctors_count: item.doctors_count,
            task_finish_count: item.task_finish_count,
            data: item,
          };
          temp.push(obj);
        });
        this.data = temp;
      }
    },
    // 搜索
    onSearch(value) {
      this.current = 1;
      this.keyword = value;
      this.getTableData({
        page: this.current,
        pageSize: this.pageSize,
        keyword: this.keyword,
      });
    },
    // 编辑或新增
    async editAndAdd(record) {
      this.visible = true;
      if (!record) {
        this.title = '新增推广员';
        this.id = '';
        this.$nextTick(() => {
          this.$refs.formRef.$refs.basicForm.form.resetFields();
        });
      } else {
        this.title = '编辑推广员';
        let result = await this.$http.post('/promoter/getDrugsList', {
          id: record.id,
        });
        if (result.data.status === 1) {
          this.typeId = record.data.bind_type;
          this.id = record.id;
          let data = {
            user_realname: record.data.user_realname,
            user_nickname: record.data.user_nickname,

            sex: record.data.sex,
            provinceCity: {
              province: record.data.province_id,
              city: record.data.city_id,
            },
            mobile: record.data.mobile,
            introduction: record.data.introduction,
          };
          this.$nextTick(() => {
            this.$refs.formRef.$refs.basicForm.form.setFieldsValue(data);
          });
        }
      }
    },
    // 确定编辑或新增
    onSubmit() {
      this.$refs.formRef.$refs.basicForm.form.validateFields(
        async(err, values) => {
          console.log('onSubmit -> values', values);
          if (!err) {
            values.province_id = values.provinceCity.province;
            values.city_id = values.provinceCity.city;
            values.path = `0,${values.provinceCity.province},${values.provinceCity.city}`;
            values.drugs = values.drugs;
            this.btnIsLoading = true;
            let result = await this.$http.post('/promoter/update', {
              type: this.type,
              id: this.id,
              ...values,
            });
            this.btnIsLoading = false;
            if (result.data.status === 1) {
              this.$message.success('操作成功！');
              this.getTableData({
                page: this.current,
                pageSize: this.pageSize,
                type: this.typeId ? this.typeId : undefined,
                keyword: this.keyword,
              });
              this.visible = false;
            }
          }
        }
      );
    },
    // 取消编辑或新增
    onCancel() {
      this.visible = false;
    },
    // 查看关联企业
    async handleCompanyList(record) {
      this.visibleCompany = true;
      console.log('handleCompanyList -> record', record);
      let result = await this.$http.post('/promoter/getDrugsList', {
        id: record.id,
      });
      if (result.data.status === 1) {
        this.CompanyData = result.data.data.data_list;
      }
    },
    // 关闭查看关联企业
    onCancelCompany() {
      this.visibleCompany = false;
    },
    // 查看关联企业
    async handleDoctorList(record) {
      this.visibleDoctor = true;
      let result = await this.$http.post('/promoter/getDoctorsList', {
        id: record.id,
      });
      if (result.data.status === 1) {
        this.doctorData = result.data.data.data_list;
      }
    },
    // 关闭查看关联医生
    onCancelDoctor() {
      this.visibleDoctor = false;
    },
    // 费用明细
    handleScore(record) {
      console.log('handleScore -> record', record);
      this.$router.push({ path: '/score', query: { id: record.id } });
    },
    // 禁用 启用
    async onConfirm(record) {
      let result = await this.$http.post('/promoter/canChange', {
        id: record.id,
        user_status: record.status === 1 ? 0 : 1,
      });
      if (result.data.status === 1) {
        this.$message.success('操作成功！');
        this.getTableData({
          page: this.current,
          pageSize: this.pageSize,
          type: this.typeId ? this.typeId : undefined,
          keyword: this.keyword,
        });
      }
    },
    // 分页
    changePage(pagination) {
      this.current = pagination.current;
      this.getTableData({
        page: this.current,
        pageSize: this.pageSize,
        type: this.typeId ? this.typeId : undefined,
        keyword: this.keyword,
      });
    },
    // 关联大区
    bindArea(record) {
      pageContext.$layer.iframe({
        content: {
          content: areaPanel,
          parent: this,
          data: {
            itemData: record,
          },
        },
        area: ['900px', '600px'],
        title: '关联大区',
        shadeClose: false,
        cancel: () => {
          pageContext.$message.info('操作取消！');
        },
      });
    },
    refreshDataList() {
      this.getTableData({
        page: this.current,
        pageSize: this.pageSize,
        type: this.typeId ? this.typeId : undefined,
        keyword: this.keyword,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.client-container {
}
</style>
